import React, { useEffect, useState } from 'react';
import { getForages, getPartenaires } from '../services/api';

const Forages: React.FC = () => {
  const [forages, setForages] = useState<any[]>([]);
  const [partenaires, setPartenaires] = useState<any[]>([]);
  const [filters, setFilters] = useState<any>({});

  useEffect(() => { getPartenaires().then(r => setPartenaires(r.data)); }, []);

  useEffect(() => {
    const params: Record<string, string> = {};
    Object.entries(filters).forEach(([k, v]) => { if (v) params[k] = v as string; });
    getForages(params).then(r => setForages(r.data));
  }, [filters]);

  return (
    <div>
      <h2 style={{ marginBottom: 20, color: '#333' }}>Forages ({forages.length})</h2>

      <div className="filters-bar">
        <select value={filters.partenaire_id || ''} onChange={e => setFilters({ ...filters, partenaire_id: e.target.value })}>
          <option value="">Tous les partenaires</option>
          {partenaires.map(p => <option key={p.id} value={p.id}>{p.libelle}</option>)}
        </select>
      </div>

      <div className="data-table-wrapper">
        <table className="data-table">
          <thead>
            <tr>
              <th>Reference</th>
              <th>Libelle</th>
              <th>Partenaire</th>
              <th>Localite</th>
              <th>Profondeur</th>
              <th>Debit</th>
              <th>Annee</th>
            </tr>
          </thead>
          <tbody>
            {forages.map((f: any) => (
              <tr key={f.id}>
                <td><strong>{f.reference}</strong></td>
                <td>{f.libelle}</td>
                <td>{f.partenaire}</td>
                <td>{f.localite_nom || f.localite}</td>
                <td>{f.profondeur ? `${f.profondeur}m` : '-'}</td>
                <td>{f.debit ? `${f.debit} m3/h` : '-'}</td>
                <td>{f.annee || '-'}</td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    </div>
  );
};

export default Forages;
